import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

const normalizer = createShapeNormalizer({
	type: 'object',
	optional: true,
	shape: {
		emailEnabled: { type: 'boolean' },
		phoneEnabled: { type: 'boolean' },
		emailSubjectLine: { type: 'string', optional: true },
		emailBody: { type: 'array', optional: true, shape: { type: 'string' } },
	},
});

export const FCM_PETITION_PAGE_CONTACT_DM = createFcmConfig('petition_page_contact_dm', {
	normalizer: createJsonNormalizer(normalizer),
	defaultValue: {
		emailEnabled: false,
		phoneEnabled: false,
		emailSubjectLine: '',
		emailBody: [],
	},
});
